// 紙工通信：カテゴリ select 変更で遷移

document.addEventListener('DOMContentLoaded', () => {
  const sel = document.querySelector('select#categories');
  if (!sel) return;
  sel.addEventListener('change', () => {
    if (sel.value) location.href = sel.value;
  });
});
